<template>
  <div>
    <ac-preview
      :campaignData="getCampaignData"
      @deleteMpe="deleteMpe"
      @editMpe="editMpe"
      @updateCampaign="updateCampaign" />

    <editor-wrapper
      v-if="editing !== null"
      @discardChanges="discardChanges"
      @saveMpe="saveMpe"
      :mpeId="editing" />
    
  </div>
</template>

<script>
import ActiveCampaignPreview from '@/components/service/campaignManager/campaignPreview/ActiveCampaignPreview'
import EditorWrapper from '@/components/service/campaignManager/standaloneMpe/EditorWrapper'

import fieldBuilder from '@/assets/modules/apollo/fieldBuilder'
import nManager from '@/assets/modules/notifications/manager'
import resolver from '@/assets/modules/error/resolver'

import campaignPreview from '@/mixins/pagination/providers/campaignPreview'
import apiConnector from '@/mixins/apiConnector'

export default {
  data () {
    return {
      editing: null
    }
  },

  methods: {
    /**
     * Closes MPE editor
     */
    closeEditor () {
      this.editing = null
    },

    /**
     * Discards all changes made to given MPE
     * @param {Object} e Event
     */
    discardChanges (e) {
      this.closeEditor()
    },

    /**
     * Saves changed MPE object
     * @param {Object} e Edited MPE object
     */
    saveMpe (e) {
      let gqlObject = {
        id: this.editing,
        advertisable: e.params.advertisable,
        publishAt: e.params.startsAt,
        removeAt: e.params.expiresAt,
        type: e.type
      }
      gqlObject[e.type] = e.payload

      let media = (Object.keys(e.payloadMedia || {})).map(m => { return { url: m } })

      gqlObject[e.type][resolver.getMediaFieldName(e.type)] = media

      if (e.clearId) {
        delete gqlObject.id
      }

      let okCallback = (e) => {
        nManager.okNotification(this, 'Notification.ok.updatesSaved.label')

        this.$apollo.queries.campaigns.refetch()
        this.closeEditor()
      }

      let failCallback = (_, e) => {
        let message = 'Spremembe niso bile shranjene'
        message = resolver.resolve(e.message, message)
        nManager.nokNotification(this, message)
      }
      
      let {mutationString, dataObject, name} = fieldBuilder
        .buildGqlObject(gqlObject, 'storeMediaPlanEvent', 'mutation', [], {
          type: 'MediaPlanEventType',
          status: 'CampaignStatus'
        })

      this.sendMutation(
        mutationString,
        dataObject,
        okCallback,
        failCallback,
        name)

      this.closeEditor()
    },

    /**
     * Deletes MPE
     * @param {Object} e Object with MPE's id
     */
    deleteMpe (e) {
      let okCallback = (data) => {
        this.$apollo.queries.campaigns.refetch()
      }

      let failCallback = (_, e) => {
        let message = 'Objava se ni uspešno odstranila'
        message = resolver.resolve(e.message)
        nManager.nokNotification(this, message)

        this.advertisablePosting = false
      }

      let {mutationString, dataObject, name} = fieldBuilder
        .buildGqlObject(e, 'deleteMediaPlanEvent', 'mutation')

      this.sendMutation(
        mutationString,
        dataObject,
        okCallback,
        failCallback,
        name)
    },

    /**
     * Requests MPE editor
     * @param {Object} e MPE
     */
    editMpe (e) {
      this.editing = e.id
    },

    /**
     * Toggles campaign's status
     * @param {String} status Campaign's new status
     */
    updateCampaign (e) {
      let {mutationString, dataObject, name, okMessage, failMessage} = e
      let okCallback = (e) => {
        nManager.okNotification(this, okMessage)
        this.$apollo.queries.campaigns.refetch()
      }

      let failCallback = (_, e) => {
        message = resolver.resolve(e.message, failMessage)
        nManager.nokNotification(this, message)
      }

      this.sendMutation(
        mutationString,
        dataObject,
        okCallback,
        failCallback,
        name)
    }
  },

  computed: {
    /**
     * Gives edited campaign's id
     * @returns {String}
     */
    getCampaignId () {
      return this.$route.params.id
    },

    /**
     * Gives campaign's data - params & events
     * @returns {Object}
     */
    getCampaignData () {
      return {
        campaignInfo: this.getCampaignInfo,
        events: this.getCampaignEvents
      }
      // 
    }
  },

  components: {
    'ac-preview': ActiveCampaignPreview,
    'editor-wrapper': EditorWrapper
  },

  mixins: [
    campaignPreview,
    apiConnector
  ]
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/service/campaignManager/CampaignPreview.vue?679de81e